<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      visible
      width="620px"
      :title="$l('INDEX.dialog_title_fabrciAddContent') || '含量信息'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main ref="main" @close="close" @confirm="confirm" />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    optionName: { type: String, default: '' },
    optionNameEn: { type: String, default: '' },
  },
  methods: {
    confirm(data) {
      this.$emit('confirm', {
        ...data,
        optionName: this.optionName,
        optionNameEn: this.optionNameEn,
      })
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
